import { Injectable } from "@angular/core";
import { environment } from "../../../environments/environment";
import { ImageSEO } from "../../core/models/image-seo.model";

export interface SpotCarouselEventData {
  pageContext: string;
  pageLanguage: string;
  propertyName: string;
  propertyId: string;
  cardPosition: number;
  spotAdvertiserName?: string;
  spotAdvertiserSlug?: string;
}

@Injectable()
export class AnalyticsService {
  constructor() {}

  public init() {
    if (
      environment.googleTrackingID &&
      environment.googleTrackingID.length > 0
    ) {
      this.configTrackingID(environment.googleTrackingID);
    }
  }

  trackBannerImpression(
    banner: ImageSEO,
    position: number,
    region: string,
    placement: string = "resource_banner"
  ): void {
    if (typeof window === "undefined" || !banner.advertiserSlug) return;
    (window as any).dataLayer = (window as any).dataLayer || [];
    (window as any).dataLayer.push({
      event: "resource_banner_impression",
      ad_placement: placement,
      ad_region: region.toUpperCase(),
      advertiser_name: banner.advertiserName,
      advertiser_slug: banner.advertiserSlug,
      ad_position: position,
      ad_creative_id: `${banner.advertiserSlug}_${this.getQuarterYear()}`
    });
  }

  trackBannerClick(
    banner: ImageSEO,
    position: number,
    region: string,
    placement: string = "resource_banner"
  ): void {
    if (typeof window === "undefined" || !banner.advertiserSlug) return;
    (window as any).dataLayer = (window as any).dataLayer || [];
    (window as any).dataLayer.push({
      event: "resource_banner_click",
      ad_placement: placement,
      ad_region: region.toUpperCase(),
      advertiser_name: banner.advertiserName,
      advertiser_slug: banner.advertiserSlug,
      ad_position: position,
      ad_creative_id: `${banner.advertiserSlug}_${this.getQuarterYear()}`
    });
  }

  trackSpotCarouselImpression(data: SpotCarouselEventData): void {
    if (typeof window === "undefined") return;
    (window as any).dataLayer = (window as any).dataLayer || [];
    (window as any).dataLayer.push(
      this.buildSpotCarouselPayload("spot_carousel_impression", data)
    );
  }

  trackSpotCarouselClick(data: SpotCarouselEventData): void {
    if (typeof window === "undefined") return;
    (window as any).dataLayer = (window as any).dataLayer || [];
    (window as any).dataLayer.push(
      this.buildSpotCarouselPayload("spot_carousel_click", data)
    );
  }

  private buildSpotCarouselPayload(
    event: string,
    data: SpotCarouselEventData
  ): object {
    return {
      event,
      ad_placement: "spot_carousel",
      page_context: data.pageContext,
      page_language: data.pageLanguage,
      property_name: data.propertyName,
      property_id: data.propertyId,
      spot_advertiser_name: data.spotAdvertiserName || "",
      spot_advertiser_slug: data.spotAdvertiserSlug || "",
      card_position: Number(data.cardPosition)
    };
  }

  private getQuarterYear(): string {
    const now = new Date();
    const quarter = Math.ceil((now.getMonth() + 1) / 3);
    return `q${quarter}_${now.getFullYear()}`;
  }

  private configTrackingID(trackingId: string) {
    try {
      const script1 = document.createElement("script");
      script1.async = true;
      script1.src = "https://www.googletagmanager.com/gtag/js?id=" + trackingId;
      document.head.appendChild(script1);

      const script2 = document.createElement("script");
      var user = JSON.parse(localStorage.getItem("user"));

      script2.innerHTML =
        `
      window.dataLayer = window.dataLayer || [];
      function gtag(){dataLayer.push(arguments);}
      gtag('js', new Date());
      gtag('config', '` +
        trackingId +
        `', {'send_page_view': true});
      `;

      document.head.appendChild(script2);
    } catch (ex) {
      console.error(`Error appending google analytics: ${trackingId}`);
      console.error(ex);
    }
  }
}
